exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-styles-pages-___return-policy__mainText___Ur4b9{padding-top:20px;color:#b18433;text-align:center;font-family:Lato,Open Sans,serif}.src-components-styles-pages-___return-policy__privacyBackround___3WASb{background-color:#fff;padding:30px 100px;margin:20px 0;box-shadow:0 1px 1px 0 rgba(0,0,0,.2)}@media (max-width:991px){.src-components-styles-pages-___return-policy__privacyBackround___3WASb{padding:30px}}.src-components-styles-pages-___return-policy__privacyBackround___3WASb p{text-align:justify;padding-bottom:10px}.src-components-styles-pages-___return-policy__subtitle___1OuHJ{color:#b18433}", ""]);

// exports
exports.locals = {
	"mainText": "src-components-styles-pages-___return-policy__mainText___Ur4b9",
	"privacyBackround": "src-components-styles-pages-___return-policy__privacyBackround___3WASb",
	"subtitle": "src-components-styles-pages-___return-policy__subtitle___1OuHJ"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/sass-loader!./src/components/styles/pages/return-policy.scss
 ** module id = 925
 ** module chunks = 0
 **/